'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ToolbarListInfo = require('./components/ToolbarListInfo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ToolbarListInfo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/toolbar-list-info/index.js
// module id = 927
// module chunks = 0